module.exports = __webpack_public_path__ + "img/butterfields.97ba3039.png";